module.exports = __webpack_public_path__ + "static/media/556252_3605852191674_1087399840_n.f50a95a6.jpg";